import React from "react";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";

import { Colors } from "@/theme";
import { getLocalisationVal } from "@/utils/localizationUtil";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    borderBottomColor: Colors.TABLE_HEADER1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: Colors.TABLE_HEADER2,
  },
}));

const TableRowComponent = ({
  localization,
  loading,
  stockDeficit,
  products,
}) => {
  const localizationWithoutDecimal = {
    ...localization,
    currency_decimal: false,
  };

  const getLocalization = (value) => {
    if (parseFloat(value) !== 0) return localization;
    return localizationWithoutDecimal;
  };

  if (loading) {
    return (
      <TableBody>
        {Array.apply(null, Array(3))
          .map(function (y, i) {
            return i;
          })
          .map((id) => (
            <TableRow key={`skeleton-${id}`} sx={{ height: 80 }}>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              {products.map((product) => (
                <React.Fragment key={product.id}>
                  <StyledTableCell align="left">
                    <Skeleton variant="rounded" width={"80%"} height={30} />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Skeleton variant="rounded" width={"80%"} height={30} />
                  </StyledTableCell>
                </React.Fragment>
              ))}
            </TableRow>
          ))}
      </TableBody>
    );
  }

  return (
    <TableBody>
      {stockDeficit?.map((deficit, id) => (
        <StyledTableRow key={`item-${id}`} sx={{ height: 80 }}>
          <StyledTableCell align="left">
            {moment.utc(deficit.to).local().format("DD MMM YYYY")}
          </StyledTableCell>
          {deficit?.data?.map((item, deficitId) => (
            <React.Fragment key={`${id}-${deficitId}`}>
              <StyledTableCell align="left">
                {getLocalisationVal(
                  getLocalization(item.deficit),
                  item.deficit
                )}
                L
              </StyledTableCell>
              <StyledTableCell align="left">
                {getLocalisationVal(
                  getLocalization(item.deficit_to_date),
                  item.deficit_to_date
                )}
                L
              </StyledTableCell>
            </React.Fragment>
          ))}
        </StyledTableRow>
      ))}
    </TableBody>
  );
};

export default TableRowComponent;
